<template>
  <main class="mypage" aria-labelledby="mypage-title">
    <header class="mypage__header">
      <h1 id="mypage-title" class="title">마이페이지</h1>
    </header>

    <!-- v-else 경고 방지: template로 감싸 v-if/else 짝을 명확히 -->
    <template v-if="user">
      <section class="card" role="region" aria-label="계정 요약">
        <div class="grid two-cols">
          <!-- 기본 정보 -->
          <div class="cell">
            <h2 class="cell__title">기본 정보</h2>
            <div class="kv">
              <!-- <div class="row">
                <div class="k">회원번호</div>
                <div class="v mono">{{ user.userId || '-' }}</div>
              </div> -->
              <div class="row">
                <div class="k">이름</div>
                <div class="v">{{ user.userName || user.name || '-' }}</div>
              </div>
              <div class="row">
                <div class="k">이메일</div>
                <div class="v">{{ user.email || '-' }}</div>
              </div>
              <div class="row">
                <div class="k">가입일</div>
                <div class="v">{{ user.createdAt || '-' }}</div>
              </div>
            </div>
          </div>

          <!-- 이용 정보 -->
          <div class="cell">
            <h2 class="cell__title">이용 정보</h2>
            <div class="kv">
              <div class="row">
                <div class="k">회원유형</div>
                <div class="v">
                  <span class="badge">
                    {{
                      user.userType === 'PERSONAL'
                        ? '개인회원'
                        : user.userType === 'CORP'
                        ? '기업회원'
                        : user.userType || '-'
                    }}
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="k">플랜</div>
                <div class="v">
                  <span v-if="user.planId === 'P00001'" class="badge free">무료 회원</span>
                  <span v-else class="badge paid">유료 회원</span>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- 기업회원 전용 -->
        <div class="grid one-col" v-if="user.userType === 'CORP'">
          <div class="cell">
            <h2 class="cell__title">기업 정보</h2>
            <div class="kv">
              <div class="row">
                <div class="k">기업명</div>
                <div class="v">{{ user.corporateName || '-' }}</div>
              </div>
              <div class="row">
                <div class="k">기업 ID</div>
                <div class="v mono">{{ user.corporateId || '-' }}</div>
              </div>
            </div>
          </div>
        </div>

        <footer class="actions">
          <button class="btn btn--line" type="button" @click="goHome" aria-label="홈으로 이동">
            <span class="btn__icon" aria-hidden="true">🏠</span>
            <span>홈으로</span>
          </button>
        </footer>
      </section>
    </template>

    <p v-else class="state">로그인 정보가 없습니다.</p>
  </main>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const store = useStore()
const router = useRouter()
const user = computed(() => store.state.temp.userInfo)
function goHome() { router.push('/') }
</script>

<style scoped>
/* 폰트/타이포 (요청사항 고정) */
.mypage {
  max-width: 960px;
  margin: 12px auto;
  padding: 24px 16px 64px;
  font-family: 'Noto Sans KR', sans-serif;
}
.title {
  font-size: 1.625rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  margin: 16px 0px;
}
p { font-size: 0.95rem; }

.subtitle {
  color: #6b7280;
  margin-bottom: 20px;
}

/* 카드 */
.card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 22px;
  box-shadow: 0 6px 24px rgba(0,0,0,.06);
}

/* 그리드 (요청: grid 사용) */
.grid { display: grid; gap: 20px; }
.two-cols { grid-template-columns: 1fr 1fr; }
.one-col { grid-template-columns: 1fr; }
@media (max-width: 960px) { .two-cols { grid-template-columns: 1fr; } }

/* 섹션 타이틀 */
.cell__title {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 12px;
}

/* 키-밸류 표 */
.kv { display: grid; gap: 0; }
.kv .row {
  display: grid;
  grid-template-columns: 160px 1fr;
  align-items: center;
  padding: 10px 0;
  border-top: 1px dashed #e5e7eb;
}
.kv .row:first-child { border-top: 0; }
.k { color: #6b7280; }
.v { font-weight: 600; line-height: 1.4; }
.mono { font-variant-numeric: tabular-nums; }

/* 플랜/뱃지 */
.plan-wrap { display: inline-flex; gap: 8px; align-items: center; }
.plan {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  background: #eef2ff;
  color: #3730a3;
  font-size: 0.85rem;
  border: 1px solid #e0e7ff;
}
.badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  font-size: 0.85rem;
}
.badge.free { background: #e0f2fe; color: #0369a1; border-color: #bae6fd; }
.badge.paid { background: #fef3c7; color: #92400e; border-color: #fde68a; }
.muted { color: #9ca3af; font-weight: 500; }

/* 상태 점 표시(아이콘 대체, 접근성/가독성 좋음) */
.status { display: inline-flex; align-items: center; gap: 8px; }
.dot {
  width: 10px; height: 10px; border-radius: 50%;
  display: inline-block;
  box-shadow: 0 0 0 3px rgba(0,0,0,0.02) inset;
}
.dot.ok { background: #10b981; }
.dot.stop { background: #ef4444; }

/* 액션 버튼 */
.actions { display: flex; gap: 10px; margin-top: 20px; }
.btn {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 11px 16px;
  border-radius: 12px;
  border: 1px solid #1d2088;
  background: #1d2088;
  color: #fff;
  font-weight: 700;
  transition: transform .2s ease, box-shadow .2s ease, background .2s ease;
}
.btn:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(0,0,0,0.12); }
.btn:active { transform: translateY(0); box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
.btn--line { background: #fff; color: #1d2088; }
.btn__icon { font-size: 1rem; line-height: 1; }

/* 빈 상태 */
.state {
  background: #fff;
  border: 1px dashed #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  text-align: center;
  color: #6b7280;
}
</style>
